import type { StopType } from './trip-updates';

export const enum PickupDropoffType {
  ALLOWED = 0,
  NOT_ALLOWED = 1,
  MUST_CONTACT_AGENCY = 2,
  MUST_CONTACT_DRIVER = 3,
}

export enum LocationType {
  STOP = 0,
  STATION = 1,
}

export interface StopTime {
  arrival_time: number; // Not a `string` from GTFS spec (Type Hour), but number of seconds since GTFS Midnight ...
  departure_time: number; // Not a `string` from GTFS spec (Type Hour), but number of seconds since GTFS Midnight ...
  stop_id: string;
  stop_sequence: number;
  stop_headsign?: string;
  pickup_type?: PickupDropoffType;
  drop_off_type?: PickupDropoffType;
  continuous_pickup?: PickupDropoffType;
  continuous_drop_off?: PickupDropoffType;
  shape_dist_traveled?: number;
  timepoint?: 0 | 1;
}

export interface StopTimeData {
  departure_time: number;
  departure_ts: number;
  first_stop: boolean;
  last_stop: boolean;
  route_id: string;
  service_date: string;
  shape_id: string;
  stop_id: string;
  stop_sequence: number;
  trip_headsign: string;
  trip_id: string;
  trip_pending?: boolean;
  trip_pending_distance?: number;
  device_id?: string;
  estimated_departure_ts?: number;
  pickup_type?: number;
  realTime?: boolean;
  time?: string;
  timestamp?: number;
}

export interface Calendar {
  service_id: string;
  start_date: string;
  end_date: string;
  monday: number;
  tuesday: number;
  wednesday: number;
  thursday: number;
  friday: number;
  saturday: number;
  sunday: number;
}

export interface Stop {
  location_type: LocationType;
  stop_code?: string;
  stop_desc?: string;
  stop_lat: number;
  stop_lon: number;
  stop_name: string;
  zone_id?: string;
  stop_id: string;
  parent_station: string;
  platform_code?: string;
  wheelchair_boarding?: number;
  distance?: number;
  type?: StopType;
}

export interface CalendarDate {
  date: string;
  exception_type: number;
  service_id: string;
}

export interface Geometry {
  type: string;
  coordinates: Array<[number, number]>;
}

export interface Shape {
  source: string;
  geometry: Geometry;
  routes: string[];
  shape_id: string;
  // additional info calculated in front
  routeId?: string;
  routeIds?: string[];
  color?: string;
}

export interface Route {
  agency_id?: string;
  route_color?: string;
  route_desc?: string;
  route_id: string;
  route_long_name?: string;
  route_short_name: string;
  route_sort_order?: number;
  route_text_color?: string;
  route_type: number;
  route_url?: string;
  // data calculated in front
  hasServiceToday?: boolean;
  endOfService?: boolean;
}
export interface Trip {
  trip_id: string;
  block_id?: string;
  route_id: string;
  wheelchair_accessible?: number;
  bikes_allowed?: number;
  direction_id?: number;
  trip_headsign: string;
  shape_id: string;
  service_id: string;
  trip_short_name?: string;
  team_id?: string;
  stop_times: Array<StopTime>;
  midnight: number;
  slack: number;
  // Set on the trips of a service day; the API's trips do not carry it.
  service_date?: string;
  pickup_type?: number;
}
